export enum ViewportMediaQuery {
  Mobile = 'print, screen and (max-width: 599px)',
  Tablet = 'print, screen and (min-width: 600px) and (max-width: 1239px)',
  Desktop = 'print, screen and (min-width: 1240px)',
  Short = 'print, screen and (max-height: 720px)',
  Default = Mobile,
}
